import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {VisitScheduleDayModel} from "../../../models/visit-schedule-day.model";

interface OptimizationDaySelectDialogModel {
  visitDays: VisitScheduleDayModel[];
}

require('./optimization-day-select-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-optimization-day-select-dialog',
  templateUrl: './optimization-day-select-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptimizationDaySelectDialogComponent implements OnInit {

  @Output() onClose = new EventEmitter<any>();

  public visitDays: VisitScheduleDayModel[];
  public selectedDayIds: string[] = [];
  public dispatchedDaysMap: { [dayId: string]: boolean } = {};

  constructor(@Inject(PANEL_DATA) public data: OptimizationDaySelectDialogModel) {
  }

  ngOnInit() {
    this.visitDays = this.data.visitDays;
    // Create map of dispatched days
    this.dispatchedDaysMap = {};
    this.visitDays.forEach(day => {
      this.dispatchedDaysMap[day.id] = day.totals?.dispatched === true;
    });
  }

  onCancel() {
    this.onClose.emit();
  }

  onSubmit() {
    this.onClose.emit(this.selectedDayIds);
  }

  isSelected(dayId: string) {
    return this.selectedDayIds.includes(dayId);
  }

  onToggleSelect(dayId) {
    // Prevent toggling if the day is dispatched
    if (this.dispatchedDaysMap[dayId]) {
      return;
    }

    if (this.isSelected(dayId)) {
      // Create new array reference for change detection
      this.selectedDayIds = this.selectedDayIds.filter(selectedDayId => selectedDayId !== dayId);
    } else {
      // Create new array reference for change detection
      this.selectedDayIds = [...this.selectedDayIds, dayId];
    }
  }

  onToggleSelectAll() {
    if (!!this.selectedDayIds.length) {
      this.selectedDayIds = [];
    } else {
      // Get only non-dispatched days
      const nonDispatchedDayIds = this.visitDays
        .filter(vd => !this.dispatchedDaysMap[vd.id])
        .map(vd => vd.id);
      // Select all non-dispatched days
      this.selectedDayIds = [...new Set([...this.selectedDayIds, ...nonDispatchedDayIds])];
    }
  }

}
